import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contacts-page" }
const _hoisted_2 = { class: "contact-hero" }
const _hoisted_3 = { class: "contact-hero-links" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "contacts-grid" }
const _hoisted_7 = { class: "contact-info" }
const _hoisted_8 = { class: "contact-phone" }
const _hoisted_9 = { class: "contact-form-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "contact-hero-title" }, "Свяжитесь с нами", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              href: "tel:+79180301137",
              class: "contact-hero-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackPhone('89180301137')))
            }, "8 (918) 030-11-37"),
            _createElementVNode("a", {
              href: "tel:+79627667256",
              class: "contact-hero-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackPhone('89627667256')))
            }, "8 (962) 766-72-56")
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("a", {
            href: "mailto:PSKMontag23@yandex.ru",
            class: "contact-hero-email"
          }, "PSKMontag23@yandex.ru", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Главная", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, " » ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Контактная информация", -1))
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "page-title" }, "Контактная информация", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "contact-company" }, "Завод стальных дверей «ПСК Монтаж»", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "contact-address" }, "Республика Адыгея, хутор Новый Сад, ул. Дорожная, 1", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "contact-tax" }, "ИНН 2312338712, КПП 231201001", -1)),
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("a", {
                  href: "tel:+79180301137",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackPhone('89180301137')))
                }, "8 (918) 030-11-37"),
                _cache[9] || (_cache[9] = _createTextVNode(", ", -1)),
                _createElementVNode("a", {
                  href: "tel:+79627667256",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackPhone('89627667256')))
                }, "8 (962) 766-72-56")
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "contact-email" }, [
                _createElementVNode("a", { href: "mailto:PSKMontag23@yandex.ru" }, "PSKMontag23@yandex.ru")
              ], -1)),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "contact-site" }, [
                _createElementVNode("a", {
                  href: "https://PSK-montag.ru",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "PSK-montag.ru")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "form-note" }, "Заполните форму и мы свяжемся с вами в ближайшее время", -1)),
              _createVNode(_component_ContactForm)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}